module.exports = __webpack_public_path__ + "static/media/confluence.f575d04e.svg";